export default __webpack_public_path__ + "static/media/qingpi_h5mgr.db067325.svg";